var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9766 7.52441V3.02441H16.4766",
    stroke: "#102039",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20687 19.0004C7.94037 21.7344 12.3724 21.7344 15.1064 19.0004C15.7572 18.3511 16.2733 17.5795 16.6251 16.7302C16.9769 15.8808 17.1575 14.9703 17.1564 14.0509C17.1575 13.1315 16.977 12.2209 16.6252 11.3714C16.2734 10.5219 15.7573 9.75031 15.1064 9.10091C12.3724 6.36741 7.94038 6.36741 5.20638 9.10091C2.47288 11.8349 2.47288 16.2669 5.20638 19.0009L5.20687 19.0004Z",
    stroke: "#102039",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9.00041L19.976 4.02441",
    stroke: "#102039",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGender);
export default __webpack_public_path__ + "static/media/gender.5bd46c288f4de0ec8be594794f5f1aa1.svg";
export { ForwardRef as ReactComponent };